<template>
  <v-card>
    <v-card-title class="blue darken-4 white--text"
      ><v-toolbar-title class="text-uppercase">{{ title }}</v-toolbar-title>
      <v-spacer />
      <v-icon color="white" @click="$emit('close')">close</v-icon>
    </v-card-title>
    <v-card-text>
      <slot></slot>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="d-flex justify-space-between pa-6" v-if="isActionsShown">
      <v-btn class="text-none text-uppercase" outlined @click="$emit('close')">Huỷ</v-btn>
      <v-btn color="primary text-none text-uppercase" elevation="0" :loading="loading" @click="$emit('save')">{{
        saveTitle
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    title: String,
    loading: {
      type: Boolean,
      default: false,
    },
    isActionsShown: {
      type: Boolean,
      default: true,
    },
    saveTitle: {
      type: String,
      default: 'Lưu',
    },
  },
}
</script>
